import React, { useEffect, useState } from 'react'
import useApp from 'hooks/useApp'
import { Button, Switch } from 'components'
import styles from './index.module.css'
import Lib from 'library'
import { useNavigate } from 'react-router-dom'


const DataSelect = () => {

	const App = useApp()
	const navigate = useNavigate()

	const [checkData, setCheckdata] = useState(); // 공유 항목 별 연동할 데이터 존재 여부
	const [myData, setMyData] = useState();
	const [checkCar, setCheckCar] = useState(); // 자동자 활성화 여부
	const [checkCrdt, setCheckCrdt] = useState(); // 신용 활성화 여부
	const [checkHouse, setCheckHouse] = useState(); // 집 활성화 여부
	const [checkIncm, setCheckIncm] = useState(); // 소득 활성화 여부
	const [checkMdata, setCheckMdata] = useState(); // 마이데이터 활성화 여부

	const [disabled, setDisabled] = useState(true)

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	//다음버튼 활성화(신용, 마이데이터)
	useEffect(() => {
		if (checkCrdt || checkMdata) {
			setDisabled(false)
		} else {
			setDisabled(true)
		}
	}, [checkCrdt, checkMdata])

	useEffect(() => {
		Lib.post(`/api/data/crtf/dataupddt`, (data) => {
			console.log({ data });
			setCheckdata(data);
			//setCheckCar(data.car ? true : false);
			setCheckCrdt(data?.crdt ? true : false);
			//setCheckHouse(data.house ? true : false);
			//setCheckIncm(data.incm ? true : false);
			// setCheckMdata(data?.mdata ? true : false);
		});

		Lib.get(`/api/data/v2/lnkup/chck`, data => {
			setMyData(data.hasLnkupData);
			setCheckMdata(data.hasLnkupData);
		})

	}, [])


	const onDetailView = () => {
		navigate("/home/DataDetail", {
			state: {
				carYn: checkCar ? 'Y' : 'N',
				crdtYn: checkCrdt ? 'Y' : 'N',
				houseYn: checkHouse ? 'Y' : 'N',
				incmYn: checkIncm ? 'Y' : 'N',
				mdataYn: checkMdata ? 'Y' : 'N',
			}
		})
	}

	return (
		<div className="page">
			<div className="flex_1 padding pb_0">
				<h3>공유하실 데이터를 선택해주세요.</h3>
				<span className="mt_20" style={{ color: "#666" }}>기존 연동된 데이터를 증명서로 변환하여<br />
					주변 지인에게 쉽고 간단하게 공유가 가능해요.</span>
				<hr className="my_40" />
				<ul className={`${styles["data-check"]}`}>
					<li>
						<div>
							<p>신용</p>
							{checkData && checkData.crdt ?
								<span>마지막 업데이트 : {checkData && checkData.crdt}</span>
								:
								<span className="text-red">현재 연동된 데이터가 없어요</span>
							}
						</div>
						<Switch offText="OFF" on={checkData && checkData.crdt ? true : false} disabled={checkData && checkData.crdt ? false : true} onToggle={() => setCheckCrdt(!checkCrdt)}>ON</Switch>
					</li>
					{/* <li>
						<div>
							<p>소득</p>
							{checkData && checkData.incm ? 
								<span>마지막 업데이트 : {checkData && checkData.incm}</span>
							: 
								<span className="text-red">현재 연동된 데이터가 없어요</span>
							}
						</div>
						<Switch offText="OFF" on={checkData && checkData.incm ? true : false} disabled={checkData && checkData.incm ? false : true} onToggle={() => setCheckIncm(!checkIncm)}>ON</Switch>
					</li> */}
					<li>
						<div>
							<p>마이데이터</p>
							{checkData && checkData.mdata ?
								<span>마지막 업데이트 : {checkData && checkData.mdata}</span>
								:
								<span className="text-red">현재 연동된 데이터가 없어요</span>
							}
						</div>
						<Switch offText="OFF" on={checkMdata && checkMdata ? true : false} disabled={myData ? false : true} onToggle={() => setCheckMdata(!checkMdata)}>ON</Switch>
					</li>
					{/* <li>
						<div>
							<p>자동차</p>
							{checkData && checkData.car ? 
								<span>마지막 업데이트 : {checkData && checkData.car}</span>
							: 
								<span className="text-red">현재 연동된 데이터가 없어요</span>
							}
						</div>
						<Switch offText="OFF" on={checkData && checkData.car ? true : false} disabled={checkData && checkData.car ? false : true} onToggle={() => setCheckCar(!checkCar)}>ON</Switch>
					</li>
					<li>
						<div>
							<p>집</p>
							{checkData && checkData.house ? 
								<span>마지막 업데이트 : {checkData && checkData.house}</span>
							: 
								<span className="text-red">현재 연동된 데이터가 없어요</span>
							}
						</div>
						<Switch offText="OFF" on={checkData && checkData.house ? true : false} disabled={checkData && checkData.house ? false : true} onToggle={() => setCheckHouse(!checkHouse)}>ON</Switch>
					</li> */}
				</ul>
				<div className={`${styles.notice} mt_50`}>
					<p>유의사항</p>
					<ul className="mt_10">
						<li>- 실제 데이터가 없거나 연동되지 않은 경우 정보를 불러 올 수 없어요. 공유 전 필요한 항목에 대해서 먼저 연동해주세요.</li>
						<li>- 자동차/집 정보는 사용자가 직접 입력한 정보로 100% 정확한 데이터가 아닐 수 있어요.</li>
						<li>- 공유된 URL은 설정시간 만료 시 소진돼요.</li>
					</ul>
				</div>
			</div>
			<div className="flex-shrink_0 padding">
				<Button disabled={disabled} className="btn btn--big" onClick={onDetailView}>다음</Button>
			</div>
		</div>
	)
}

export default DataSelect
